export async function requestMicrophoneAccess() {
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    return {
      ok: false,
      error:
        'This browser does not support microphone access. Please open the link in Chrome or Safari.',
    };
  }

  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,
      },
      video: false,
    });
    stream.getTracks().forEach((t) => t.stop());
    return { ok: true };
  } catch (err) {
    const name = err && err.name;
    if (name === 'NotAllowedError' || name === 'PermissionDeniedError') {
      return {
        ok: false,
        error:
          'Microphone permission was denied. Please allow the microphone in your browser settings and try again.',
      };
    }
    if (name === 'NotFoundError') {
      return {
        ok: false,
        error: 'No microphone was found on this device.',
      };
    }
    return {
      ok: false,
      error: 'Could not access the microphone. Please try again.',
    };
  }
}

export function startWakeLock() {
  let wakeLock = null;
  let released = false;

  const request = async () => {
    if (released) return;
    if (!('wakeLock' in navigator) || !navigator.wakeLock) return;
    try {
      wakeLock = await navigator.wakeLock.request('screen');
      wakeLock.addEventListener('release', () => {
        wakeLock = null;
      });
    } catch (err) {
      // unsupported / denied
    }
  };

  const onVisibility = () => {
    if (document.visibilityState === 'visible') {
      request();
    }
  };

  request();
  document.addEventListener('visibilitychange', onVisibility);

  return {
    release: async () => {
      released = true;
      document.removeEventListener('visibilitychange', onVisibility);
      if (wakeLock) {
        try {
          await wakeLock.release();
        } catch (err) {
          // ignore
        }
        wakeLock = null;
      }
    },
  };
}

export async function unlockAudio() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    if (ctx.state === 'suspended') {
      await ctx.resume();
    }
    const buffer = ctx.createBuffer(1, 1, 22050);
    const source = ctx.createBufferSource();
    source.buffer = buffer;
    source.connect(ctx.destination);
    source.start(0);
    setTimeout(() => {
      try {
        ctx.close();
      } catch (err) {
        // ignore
      }
    }, 200);
  } catch (err) {
    // ignore
  }
}
